"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const Dropdown_1 = __importDefault(require("../Icons/Dropdown"));
const styles_1 = require("./styles");
const FormButton = props => {
  const {
    children,
    isDisabled,
    isClicked,
    onClick,
    dataAutomation = 'button'
  } = props;
  const handleOnClick = e => {
    if (isDisabled) {
      return;
    }
    onClick(e);
  };
  return (0, jsx_runtime_1.jsxs)(styles_1.StyledFormButton, {
    isDisabled: isDisabled,
    isClicked: isClicked,
    onClick: handleOnClick,
    "data-automation": dataAutomation,
    children: [(0, jsx_runtime_1.jsx)(styles_1.TextContainer, {
      children: children
    }), (0, jsx_runtime_1.jsx)(Dropdown_1.default, {})]
  });
};
exports.default = FormButton;